export default __webpack_public_path__ + "static/media/court-warrants-executions.e292e101.jpg";